<div class="dialog-header">
  <h3 matDialogTitle id="add-user-success-title">Add user success</h3>
  <button
    id="close"
    class="close-button"
    mat-icon-button
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div class="row">
    <div class="col-md-12" id="add-user-success-message">
      User Addition Successful with<br />
      User Id: {{ userName }}<br />
      For Site Name: {{ siteName }}<br />
    </div>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-footer>
  <button
    type="button"
    id="closebtn"
    class="btn mat-raised-button pull-right alignClose"
    (click)="close(false)"
  >
    Close
  </button>
</mat-dialog-footer>
